import React, { Component } from 'react'

import '../css/BisharatMain.css';
import AuthService from "../services/AuthService";
import Login from '../pages/Login';
import ActivityService from '../services/ActivityService';
import Moment from 'moment';
import Calendar from 'react-calendar';
import translate from '../languages/translate';

export default class Activities extends Component {
    state = {
        activities: [],
        filteredActivities:[],
        selectedActivity: {},
        showSelectedDate: false,
        "dateOfActivity": '',
        search: ''
    }

    componentDidMount() {
        this.refreshActivities();
        this.refreshFilteredActivites();
        this.setState({ selectedActivity: '' });
    }

    refreshActivities = () => {
        const loggedInUser = AuthService.getCurrentUser();
        const whatRole = AuthService.getUserRole();
        if (!loggedInUser || (whatRole === ('USER'))) { } else {
            ActivityService.getAllActivities()
                .then(res => {
                    const activities = res.data;
                    this.setState({ activities });
                })
        }
    }

    refreshFilteredActivites = () => {
        const loggedInUser = AuthService.getCurrentUser();
        const whatRole = AuthService.getUserRole();
        if (!loggedInUser || (whatRole === ('USER'))) { } else {
            ActivityService.getActivitiesByDate(Moment(new Date()).format('DD-MM-YYYY'))
            .then(res => {
                const filteredActivities = res.data;
                this.setState({ filteredActivities });
            })
        } 
    }

    onChangeDate = dateOfActivity => this.setState({
        dateOfActivity,
        search: Moment(dateOfActivity).format('DD-MM-YYYY')
    }


    );


    onchangeFind = (event) => {
        this.setState({ search: event.target.value })
    }

    filterFunction = (activity) => {
        return activity.dateOfActivity === this.state.search;
    }




    showActivity(activity) {
        this.setState({ selectedActivity: activity })
        this.setState({ showActivityClicked: true })

    }




    gotoActivity(id) {
            window.open(`/family-activities/${id}`, '_self');
        }

    gotoActivityLink(activityLink) {
        window.open(`${activityLink}`,'_blank');
    }


    render() {

        const loggedInUser = AuthService.getCurrentUser();
        const whatRole = AuthService.getUserRole();
        return (

            <div>
                { !loggedInUser || (whatRole === ('USER')) ?
                    <div className="login-class">
                        <Login></Login>
                    </div> :
                    <div className="top-level-page-main activities">
                        <div className="activities grid-left-page">
                            <div className="calendar-section">
                                <Calendar className="react-calendar"
                                    onChange={this.onChangeDate}
                                    value={this.state.dateOfActivity}
                                />
                            </div>
                        </div>

                            <div className="activities grid-center-page">
                                {this.state.dateOfActivity ?
                                    <div className="show-selected-date">
                                        <h2>  {this.state.search}-{translate("this-day-activity")}  </h2>
                                        {this.state.activities.filter(this.filterFunction).map(activity => (
                                            <div className="one-activity" key={activity.id}>
                                             {/* <button className="btn" onClick={()=>this.gotoActivity(activity.id)}>Link to Activity</button> */}
                                             <button className="btn" onClick={()=>this.gotoActivityLink(activity.activityLink)}>{translate("activity-link")} </button>
                                             <h4>{activity.dateOfActivity}</h4>
                                                 <h4>{activity.activityName}</h4>
                                            </div>

                                        ))}



                                    </div> :
                                    <div>
                                        <h2>{translate("pick-date-act")}</h2>
                                    </div>
                                }


                            </div>

                            <div className="activities grid-right-page">
                                <div className="show-all-activites">
                                    <h2>  {translate("oncoming-act")}</h2>
                                    {this.state.filteredActivities.map(activity => (
                                        <div className="one-activity" key={activity.id}>
                                            {/* <a className="btn" onClick={()=>this.gotoActivity(activity.id)}> Link to Activity </a> */}
                                            <button className="btn" onClick={()=>this.gotoActivityLink(activity.activityLink)}>{translate("activity-link")}</button>
                                            <h4>{activity.dateOfActivity}</h4>
                                            <h4>{activity.activityName}</h4>
                                        </div>

                                    ))}



                                </div>
                            </div>
                        </div>  
                
              
    }
            </div>

        )
    }
}
